import { Box, Typography, Paper } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { ADALONG_COLORS } from '../../styles';

function NotFound() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '70vh',
      }}
    >
      <Paper
        elevation={3}
        sx={{
          padding: 4,
          textAlign: 'center',
          maxWidth: 400,
          backgroundColor: ADALONG_COLORS.LIGHT_BLACK,
          color: ADALONG_COLORS.LIGHT_WHITE,
        }}
      >
        <ErrorOutlineIcon sx={{ fontSize: 64, color: ADALONG_COLORS.FLASH_RED, mb: 2 }} />
        <Typography variant="h4" gutterBottom>
          404 - Page Not Found
        </Typography>
        <Typography variant="body1" sx={{ color: ADALONG_COLORS.LIGHT_GRAY }}>
          This page doesn't exist.
        </Typography>
      </Paper>
    </Box>
  );
}

export default NotFound;